/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/base-menu-item.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseNavigationColumnFragment} from '@amblique/contentful/app/contentful/fragments/navigation-column/base-navigation-column.fragment';

export const MenuItemFragment = gql`
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseMenuItemFragment}
  ${BaseNavigationColumnFragment}

  fragment MenuItemFragment on MenuItem {
    ...BaseMenuItemFragment

    featuredLink {
      ...BaseLinkFragment
    }
    imagesCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
      }
    }
    imagesCursorCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
      }
    }
    link {
      ...BaseLinkFragment
    }
    submenuCollection {
      items {
        __typename
        ... on NavigationColumn {
          ...BaseNavigationColumnFragment
        }
      }
    }
    submenuCursorCollection {
      items {
        __typename
        ... on NavigationColumn {
          ...BaseNavigationColumnFragment
        }
      }
    }
  }
`;
